import { Fragment, FunctionComponent } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators, State } from "@App/state";
import { Motorization } from "@App/types";
import { useTranslation } from "react-i18next";
import { MotorizationList } from "@App/Components/Vehicletree/MotorizationList/MotorizationList";
import { bindActionCreators } from "@reduxjs/toolkit";
import { FunnelHeader } from "@App/Components/Funnel/FunnelHeader";
import { Loader } from "@App/Components/Loader";

export type MotorizationsProps = {
  headline: string;
  step: number;
  maxSteps: number;
  onKeyNumberLinkClick: () => void;
  onSubmit?: (motorization: Motorization) => void;
};

export const Motorizations: FunctionComponent<MotorizationsProps> = ({
  headline,
  step,
  maxSteps,
  onKeyNumberLinkClick,
  onSubmit,
}: MotorizationsProps) => {
  const { t } = useTranslation();
  const brand = useSelector((state: State) => state.orders.brand);
  const generation = useSelector((state: State) => state.orders.generation);

  const dispatch = useDispatch();
  const { chooseMotorization } = bindActionCreators(actionCreators, dispatch);

  const setMotorization = (motorization: Motorization): void => {
    chooseMotorization(motorization);
    onSubmit && onSubmit(motorization);
  };

  if (!generation) {
    return (
      <div className="h-screen w-screen grid place-items-center">
        <Loader />
      </div>
    );
  }

  return (
    <Fragment>
      <div
        className="
                    container bg-white
                    pt-10 pb-12
                "
      >
        <FunnelHeader
          heading={headline}
          step={step}
          maxSteps={maxSteps}
          subheading={t("motorization.headline", {
            brand: brand.name,
            generation: generation.name.split(" (")[0],
          })}
        />
        <div className="text-sm text-neutral-700 mb-8">
          <i>
            {t("motorization.skip-steps")}{" "}
            <span
              className={"font-bold cursor-pointer underline text-primary"}
              onClick={onKeyNumberLinkClick}
            >
              {t("motorization.vehicle-registration")}
            </span>
            .
          </i>
        </div>
        {generation && <MotorizationList onClick={setMotorization} />}
      </div>
    </Fragment>
  );
};
